import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
import Header from '../../features/Header';
import Footer from '../../features/Footer';

const NetworkError = React.lazy(() =>
  import('../../views/NetworkError/NetworkError')
);

const params = [];

const NetworkErrorRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<Header />} footer={<Footer />}>
        <NetworkError />
      </Layout>
    </RouteParameter>
  );
};

NetworkErrorRoute.propTypes = {};

NetworkErrorRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(NetworkErrorRoute);
